import http, { url } from '../../http'

const API_URL = "training"

class trainingAPI {

  async save(training) {
    const response = await http(`${API_URL}/save`, 'POST', training)
    return response
  }
 
  async getAllTraining(page, search) { 
    const response = await http(`${API_URL}?page=${page}&search=${search}` , 'POST')
    return response
  } 
 
  async getTraining(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateTraining(id, training) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', training)
    return response
  }

  

 
  
}

export default new trainingAPI()